(() => {
  const selector = ".m-product-media--mobile__atwl-button, .dp2-wishlist";

  function getProductSections(root = document) {
    if (root.matches && root.matches(".m-main-product")) return [root];
    return [...root.querySelectorAll(".m-main-product")];
  }

  function placeWishlistButton(root = document) {
    if (!document.body.classList.contains("default-product-2")) return;

    getProductSections(root).forEach((productSection) => {
      const formWrapper = productSection.querySelector(".m-product-form--wrapper");
      const wishlistButton = productSection.querySelector(selector);

      if (!formWrapper || !wishlistButton) return;

      wishlistButton.classList.remove("m-product-media--mobile__atwl-button");
      wishlistButton.classList.add("dp2-wishlist");
      formWrapper.appendChild(wishlistButton);
    });
  }

  function init(root = document) {
    placeWishlistButton(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
